import React, { useState } from 'react';
import { exportAPI } from '../services/api';
import { useToast } from '../ToastContext';

const EXPORTS = [
  ['sales',     'Sales'],
  ['payments',  'Payments received'],
  ['debtors',   'Who owes you'],
  ['expenses',  'Expenses'],
  ['purchases', 'Purchases'],
  ['products',  'Products & stock'],
  ['customers', 'Customers'],
];

// Download the business's records as CSV (opens in Excel / Google Sheets).
// Works on every plan — and while a lapsed account is read-only.
export default function ExportPanel() {
  const { toast } = useToast();
  const [busy, setBusy] = useState(null);

  const download = async (kind) => {
    setBusy(kind);
    try {
      await exportAPI.download(kind);
    } catch (err) {
      toast(err.response ? 'Export failed' : 'You need to be online to export', 'error');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="card" style={{ marginBottom: '1.5rem' }}>
      <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--color-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.4rem' }}>
        Export your data
      </div>
      <p className="text-muted" style={{ fontSize: '0.8rem', marginBottom: '0.75rem' }}>
        Download your records as spreadsheets (CSV). Your data is always yours to take.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '0.5rem' }}>
        {EXPORTS.map(([kind, label]) => (
          <button key={kind} className="btn-ghost" style={{ padding: '0.5rem', fontSize: '0.8rem' }}
            disabled={busy !== null} onClick={() => download(kind)}>
            {busy === kind ? 'Preparing…' : `⬇ ${label}`}
          </button>
        ))}
      </div>
    </div>
  );
}
